<template>
  <div>
    <v-dialog v-model="dialog" flat persistent width="900px" color="white">
      <v-card flat color="grey lighten-4" width="700px" class="mx-auto pa-8 mt-7">
        <a href="https://www.firstcryintellitots.com/"
          ><v-btn icon color="error" absolute top right><v-icon>mdi-close-circle</v-icon></v-btn></a
        >
        <v-card-title class="primary--text display-3 font-weight-bold justify-center">Thank You !</v-card-title>
        <v-icon class="d-flex justify-center my-2" size="150" color="pink">mdi-emoticon</v-icon>
        <v-card-subtitle class="d-flex justify-center my-2 title">Your Admission form is submitted successfully.</v-card-subtitle>
      </v-card>
    </v-dialog>
    <section class="">
      <div class="level-item">
        <img style="max-width: 20%;" src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/intellitots-logo_updated.png" />
      </div>
      <br />

      <div class="level-item">
        <p class="title is-2">Admission Form</p>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <div v-if="parentdata">
        <form class="container" @submit.prevent="saveRegistration()">
          <div>
            <div class="container">
              <FranchiseeElement v-model="parentdata" isWritable="false" isRequired="true" />
            </div>
            <div class="container">
              <StudentElement :key="studentElementComponentRefresh" :isUniformSelection="!isUniformSelectionNotRequired" v-model="parentdata" isWritable="true" isRequired="true" subType="admission_offon" />
            </div>
            <div class="container">
              <RegParentElement :formType="this.typeForm" :isWritable="this.message" parentType="father" v-model="studentData" />
            </div>
            <div class="container">
              <RegParentElement :formType="this.typeForm" :isWritable="this.message" parentType="mother" v-model="studentData" />
            </div>

            <div class="container">
              <AddressElement v-model="parentdata" isWritable="true" formType="applicationForm" />
            </div>
            <div class="container">
              <OtherElement :formType="this.typeForm" :isWritable="this.message" v-model="parentdata" />
            </div>
            <div class="container">
              <SiblingElement :formType="this.typeForm" :isWritable="this.message" v-model="registrationData" />
            </div>
            <div class="container">
              <HealthElement :formType="this.typeForm" :isWritable="this.message" v-model="registrationData" />
            </div>
            <div class="container" v-if="this.isLoaded === 'true'">
              <RegDocumentElement :formType="this.typeForm" :isWritable="this.message" v-model="registrationData" :enquiryID="parentdata.id" />
            </div>
            <div class="container">
              <IAgreeCheckbox v-model="registrationData" />
            </div>

            <footer class="column has-text-right">
              <input class="button is-success" type="submit" value="Confirm" />
            </footer>
          </div>
        </form>
      </div>
      <div v-else>
        <div class="level-item">
          <p class="title is-5">Link is not valid....</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import moment from 'moment'
import FranchiseeElement from '@/components/Forms/Elements/FranchiseeElement'
import StudentElement from '@/components/Forms/Elements/StudentElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'
import HealthElement from '@/components/Forms/Elements/HealthElement'
import RegDocumentElement from '@/components/Forms/Elements/RegDocs'
import SiblingElement from '@/components/Forms/Elements/SiblingElement'
import IAgreeCheckbox from '@/components/Forms/Elements/IAgreeCheckbox'
// import ParticularList from '../Fees/payment/particularList'
import OtherElement from '@/components/Forms/Elements/OtherElement'
import RegParentElement from '@/components/Forms/Elements/RegParentElement'

export default {
  name: 'ApplicationLinkEmailCopy',
  props: ['refID'],
  components: {
    FranchiseeElement,
    StudentElement,
    RegParentElement,
    AddressElement,
    // ParticularList,
    HealthElement,
    RegDocumentElement,
    SiblingElement,
    IAgreeCheckbox,
    OtherElement
  },
  data: function () {
    return {
      checkboxGroup: ['SMS'],
      parentdata: {},
      studentData: {},
      registrationData: {},
      enableModal: false,
      enableChangeRequestModal: false,
      showSection: '',
      franchiseeName: '',
      academicYr: '',
      className: '',
      query: '',
      enquiryCode: '',
      typeForm: 'edit_registration',
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      payModal: false,
      formType: '',
      message: 'true',
      isLoaded: 'false',
      dialog: false,
      studentElementComponentRefresh: 0,
      previousGenderSelected: '',
      isUniformSelectionNotRequired: true
    }
  },
  async created () {
    await this.onstart()
    await this.writable()
  },

  methods: {
    writable: async function () {
      if (this.isLoaded === 'true') {
        this.message = 'false'
        this.typeForm = 'edit_registration'
      }
    },
    onstart: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/getReferenceDetails/${this.refID}`)
        let getRefDetails = data
        if (!_.isEmpty(getRefDetails)) {
          this.parentdata = data
          console.log('parentdata', this.parentdata)

          if (!_.isEmpty(this.parentdata.enquiryRegistrations)) {
            let registrationData = this.parentdata.enquiryRegistrations
            this.registrationData = registrationData[0]
            this.isRegistered = true
          }
          this.studentData = this.parentdata
          this.studentData.address = this.parentdata.address1
          this.parentdata.address = this.parentdata.address1
          this.parentdata.pincode = this.parentdata.pincode === 0 ? '' : this.parentdata.pincode

          this.parentdata.studentFirstName = this.parentdata.studentFirstName
          this.parentdata.studentLastName = this.parentdata.studentLastName
          this.parentdata.studentMiddleName = this.parentdata.studentMiddleName
          this.parentdata.gender = _.startCase(_.toLower(this.parentdata.gender))
          this.previousGenderSelected = this.parentdata.gender
          this.parentdata.exposureToEnglishLanguage = !_.isEmpty(this.registrationData.exposureToEnglishLanguage) ? this.registrationData.exposureToEnglishLanguage : ''
          this.parentdata.motherTongue = !_.isEmpty(this.registrationData.motherTongue) ? this.registrationData.motherTongue : ''
          this.parentdata.identificationMarks = !_.isEmpty(this.registrationData.identificationMarks) ? this.registrationData.identificationMarks : ''
          this.parentdata.emergencyContactDetails = !_.isEmpty(this.registrationData.emergencyContactDetails) ? this.registrationData.emergencyContactDetails : ''
          this.parentdata.fatherDesignation = !_.isEmpty(this.registrationData.fatherDesignation) ? this.registrationData.fatherDesignation : ''
          this.parentdata.fatherQualification = !_.isEmpty(this.registrationData.fatherQualification) ? this.registrationData.fatherQualification : ''
          this.parentdata.fatherOrganisation = !_.isEmpty(this.registrationData.fatherOrganisation) ? this.registrationData.fatherOrganisation : ''
          this.parentdata.fatherOfficePhoneNo = !_.isEmpty(this.registrationData.fatherOfficePhoneNo) ? this.registrationData.fatherOfficePhoneNo : ''
          this.parentdata.fatherOfficeAddress =
            !_.isEmpty(this.registrationData.fatherOfficeAddress) && this.registrationData.fatherOfficeAddress !== 'undefined' ? this.registrationData.fatherOfficeAddress : ''
          this.parentdata.motherDesignation =
            !_.isEmpty(this.registrationData.motherDesignation) && this.registrationData.motherDesignation !== 'undefined' ? this.registrationData.motherDesignation : ''
          this.parentdata.motherQualification =
            !_.isEmpty(this.registrationData.motherQualification) && this.registrationData.motherQualification !== 'undefined' ? this.registrationData.motherQualification : ''
          this.parentdata.motherOrganisation =
            !_.isEmpty(this.registrationData.motherOrganisation) && this.registrationData.motherOrganisation !== 'undefined' ? this.registrationData.motherOrganisation : ''
          this.parentdata.motherOfficePhoneNo =
            !_.isEmpty(this.registrationData.motherOfficePhoneNo) && this.registrationData.motherOfficePhoneNo !== 'undefined' ? this.registrationData.motherOfficePhoneNo : ''
          this.parentdata.motherOfficeAddress =
            !_.isEmpty(this.registrationData.motherOfficeAddress) && this.registrationData.motherOfficeAddress !== 'undefined' ? this.registrationData.motherOfficeAddress : ''
          this.parentdata.emergencyContactDetails =
            !_.isEmpty(this.registrationData.emergencyContactDetails) && this.registrationData.emergencyContactDetails !== 'undefined' ? this.registrationData.emergencyContactDetails : ''
          this.parentdata.siblingName =
            !_.isEmpty(this.registrationData.siblingName) && this.registrationData.siblingName !== 'undefined' && this.registrationData.siblingName !== null ? this.registrationData.siblingName : ''
          this.parentdata.siblingAge = !_.isEmpty(this.registrationData.siblingAge) && this.registrationData.siblingAge !== 'undefined' ? this.registrationData.siblingAge : ''
          this.parentdata.siblingClass = !_.isEmpty(this.registrationData.siblingClass) && this.registrationData.siblingClass !== 'undefined' ? this.registrationData.siblingClass : ''
          this.parentdata.siblingSchool = !_.isEmpty(this.registrationData.siblingSchool) && this.registrationData.siblingSchool !== 'undefined' ? this.registrationData.siblingSchool : ''
          this.parentdata.referralsChildName =
            !_.isEmpty(this.registrationData.referralsChildName) && this.registrationData.referralsChildName !== 'undefined' ? this.registrationData.referralsChildName : ''
          this.parentdata.referralsChildAge =
            !_.isEmpty(this.registrationData.referralsChildAge) && this.registrationData.referralsChildAge !== 'undefined' ? this.registrationData.referralsChildAge : ''
          this.parentdata.referralsFatherMotherName =
            !_.isEmpty(this.registrationData.referralsFatherMotherName) && this.registrationData.referralsFatherMotherName !== 'undefined' ? this.registrationData.referralsFatherMotherName : ''
          this.parentdata.referralsFatherMotherMobileNo =
            !_.isEmpty(this.registrationData.referralsFatherMotherMobileNo) && this.registrationData.referralsFatherMotherMobileNo !== 'undefined'
              ? this.registrationData.referralsFatherMotherMobileNo
              : ''
          this.parentdata.referralsRelation =
            !_.isEmpty(this.registrationData.referralsRelation) && this.registrationData.referralsRelation !== 'undefined' ? this.registrationData.referralsRelation : ''
          this.parentdata.childsReactionForNewSituation =
            !_.isEmpty(this.registrationData.childsReactionForNewSituation) && this.registrationData.childsReactionForNewSituation !== 'undefined'
              ? this.registrationData.childsReactionForNewSituation
              : ''
          this.parentdata.placeOfBirth = !_.isEmpty(this.registrationData.placeOfBirth) && this.registrationData.placeOfBirth !== 'undefined' ? this.registrationData.placeOfBirth : ''
          this.parentdata.siblingOtherSchool =
            !_.isEmpty(this.registrationData.siblingOtherSchool) && this.registrationData.siblingOtherSchool !== 'undefined' ? this.registrationData.siblingOtherSchool : ''
          this.registrationData.franchiseeID = this.parentdata.franchisee.id
          this.registrationData.dateForSeriousAccidentsOrIllnessOrOperations = this.registrationData ? this.isDate(this.registrationData.dateForSeriousAccidentsOrIllnessOrOperations) : ''
          this.registrationData.chikenpoxVaricellaVaccineDate = this.registrationData ? this.isDate(this.registrationData.chikenpoxVaricellaVaccineDate) : ''
          this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate = this.registrationData ? this.isDate(this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate) : ''
          this.registrationData.hepatitisAHepAVaccineDate = this.registrationData ? this.isDate(this.registrationData.hepatitisAHepAVaccineDate) : ''
          this.registrationData.hepatitisBHepBVaccineDate = this.registrationData ? this.isDate(this.registrationData.hepatitisBHepBVaccineDate) : ''
          this.registrationData.tetanusDTapDate = this.registrationData ? this.isDate(this.registrationData.tetanusDTapDate) : ''
          this.registrationData.diptheriaDTapVaccineDate = this.registrationData ? this.isDate(this.registrationData.diptheriaDTapVaccineDate) : ''
          this.parentdata.dateOfBirth = this.isDate(this.parentdata.dateOfBirth)
          this.parentdata.placeOfBirth = !_.isEmpty(this.registrationData.placeOfBirth) && this.registrationData.placeOfBirth !== 'undefined' ? this.registrationData.placeOfBirth : ''
          this.registrationData.enquiryID = this.enquiryID
          this.registrationData.enquiryCode = this.parentdata.enquiryCode
          this.parentdata.getAcademicYear = this.parentdata.franchiseeAcademicYear.academicYear
          let classCategory = this.parentdata.studentClass.category ? '( ' + this.parentdata.studentClass.category + ' )' : ''
          this.parentdata.getClassName = this.parentdata.studentClass.name + ' ' + classCategory
          this.parentdata.franchiseeName = !_.isEmpty(this.parentdata.franchisee) ? this.parentdata.franchisee.companyName : ''
          //   this.parentdata.motherName = !_.isEmpty(this.registrationData.motherName) && (this.registrationData.motherName !== 'undefined') ? this.registrationData.motherName : ''
          //   this.parentdata.motherOccupation = !_.isEmpty(this.registrationData.motherOccupation) ? this.registrationData.motherOccupation : ''
          this.typeForm = 'edit_registration'
          this.isLoaded = 'true'
          this.isUniformSelectionNotRequired = _.isEqual(this.parentdata.studentClass.category, constants.classCategory.BRIDGE_COURSE) || _.isEqual(
            this.parentdata.studentClass.category,
            constants.classCategory.PARENT_TODDLER
          )
          this.studentElementComponentRefresh++
        } else {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Invalid Link..',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        const stateresponse = await http.get(`${constants.API_URL}/api/states`)
        this.states = stateresponse.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    isDate: function (date) {
      if (!date) {
        return ''
      } else return moment(date).format('YYYY-MM-DD')
    },
    openModal: async function () {
      this.enableModal = true
    },
    saveRegistration: async function () {
      try {
        if (!this.isUniformSelectionNotRequired) {
          // Uniform Size Validation
          let uniforms = this.parentdata?.uniforms || []
          for (let key in uniforms) {
            for (let obj of uniforms[key]) {
              if (!obj.selectedProductDetails && !this.isUniformSelectionNotRequired) {
                if (this.previousGenderSelected !== this.parentdata.gender) {
                  return this.$buefy.toast.open({
                    message: 'Please reselect the uniform sizes as gender is updated.',
                    type: 'is-danger',
                    duration: 4000
                  })
                } else {
                  return this.$buefy.toast.open({
                    message: 'Please select all uniform sizes.',
                    type: 'is-danger',
                    duration: 4000
                  })
                }
              }
            }
          }
          if (uniforms.length === 0 && !this.isUniformSelectionNotRequired) {
            return this.$buefy.toast.open({
              message: 'Something went wrong with the unform selection.',
              type: 'is-danger',
              duration: 4000
            })
          }
        }
        if (this.parentdata.pointOfContact === 'MOTHER') {
          if (_.isEmpty(this.studentData.motherName) || _.isEmpty(this.studentData.motherEmailID) || _.isEmpty(this.studentData.motherMobile)) {
            this.loadingComponent.close()
            this.lock = false
            this.hasClicked = false
            return this.$buefy.dialog.alert({
              message: 'Please Fill Mother Details as you have selected Mother as Point of contact',
              type: 'is-danger',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',
              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
        if (!this.parentdata.dateOfBirth) {
          return this.$dialog.error({
            text: 'Date of Birth is empty!!',
            title: 'Error'
          })
        }
        if (!this.parentdata.gender) {
          return this.$dialog.error({
            text: 'Gender value is empty!!',
            title: 'Error'
          })
        }
        this.hasClicked = true
        this.loader = true
        this.parentdata.enquiry = ''
        this.loadingComponent = this.$buefy.loading.open()
        let inputData = {
          motherTongue: this.parentdata.motherTongue,
          exposureToEnglishLanguage: this.parentdata.exposureToEnglishLanguage,
          identificationMarks: this.parentdata.identificationMarks,
          franchiseeID: this.parentdata.franchisee.id,
          academicYearID: this.studentData.academicYearID,
          studentFirstName: this.parentdata.studentFirstName,
          studentMiddleName: this.parentdata.studentMiddleName,
          studentLastName: this.parentdata.studentLastName,
          fatherName: this.studentData.fatherName,
          fatherMobile: this.studentData.fatherMobile,
          fatherEmail: this.studentData.fatherEmailID,
          fatherOccupation: this.studentData.fatherOccupation,
          motherName: this.studentData.motherName,
          motherEmailID: this.studentData.motherEmailID,
          motherMobile: this.studentData.motherMobile,
          motherOccupation: this.studentData.motherOccupation,
          address1: this.parentdata.address,
          address: this.parentdata.address,
          pincode: this.studentData.pincode === 0 ? '' : this.studentData.pincode,
          country: this.studentData.countryName,
          state: this.studentData.state,
          city: this.studentData.city,
          locality: this.studentData.locality,
          dateOfBirth: this.parentdata.dateOfBirth,
          placeOfBirth: this.parentdata.placeOfBirth,
          gender: this.parentdata.gender,
          pointOfContact: this.parentdata.pointOfContact,
          guardianName: this.studentData.guardianName,
          guardianMobile: this.studentData.guardianMobile,
          guardianEmailID: this.studentData.guardianEmailID,
          fatherDesignation: this.studentData.fatherDesignation,
          fatherQualification: this.studentData.fatherQualification,
          fatherOrganisation: this.studentData.fatherOrganisation,
          fatherOfficePhoneNo: this.studentData.fatherOfficePhoneNo,
          fatherOfficeAddress: this.studentData.fatherOfficeAddress,
          motherQualification: this.studentData.motherQualification,
          motherOrganisation: this.studentData.motherOrganisation,
          motherOfficePhoneNo: this.studentData.motherOfficePhoneNo,
          motherOfficeAddress: this.studentData.motherOfficeAddress,
          motherDesignation: this.studentData.motherDesignation,
          emergencyContactDetails: this.parentdata.emergencyContactDetails,
          siblingName: this.registrationData.siblingName,
          siblingAge: this.registrationData.siblingAge,
          siblingClass: this.registrationData.siblingClass,
          siblingSchool: this.registrationData.siblingSchool,
          siblingOtherSchool: this.registrationData.siblingOtherSchool,
          referralsChildName: this.registrationData.referralsChildName,
          referralsChildAge: this.registrationData.referralsChildAge,
          referralsFatherMotherName: this.registrationData.referralsFatherMotherName,
          referralsFatherMotherMobileNo: this.registrationData.referralsFatherMotherMobileNo,
          referralsRelation: this.registrationData.referralsRelation,
          bloodGroup: this.registrationData.bloodGroup,
          anySeriousAccidentsOrIllnessOrOperarions: this.registrationData.anySeriousAccidentsOrIllnessOrOperarions,
          dateForSeriousAccidentsOrIllnessOrOperarions: this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions,
          allergiesOrAsthmaOrBreathlessness: this.registrationData.allergiesOrAsthmaOrBreathlessness,
          anyOtherAliment: this.registrationData.anyOtherAliment,
          specialCare: this.registrationData.specialCare,
          foodAllergies: this.registrationData.foodAllergies,
          drugAllergies: this.registrationData.drugAllergies,
          anyPhysicalChallengeOrLearningDifficulties: this.registrationData.anyPhysicalChallengeOrLearningDifficulties,
          prescribedMedication: this.registrationData.prescribedMedication,
          techniqueToDisciplineYourChild: this.registrationData.techniqueToDisciplineYourChild,
          childsUsualReactionToBeingDisciplined: this.registrationData.childsUsualReactionToBeingDisciplined,
          childsReactionForNewSituation: this.registrationData.childsReactionForNewSituation,
          isNewPeopleEasilyAcceptable: this.registrationData.isNewPeopleEasilyAcceptable,
          familyDoctorOrPhysicianName: this.registrationData.familyDoctorOrPhysicianName,
          familyDoctorOrPhysicianQualification: this.registrationData.familyDoctorOrPhysicianQualification,
          practicingClinicDetails: this.registrationData.practicingClinicDetails,
          practicingClinicOfficeTelephone: this.registrationData.practicingClinicOfficeTelephone,
          practicingClinicMobileNo: this.registrationData.practicingClinicMobileNo,
          practicingClinicEmailID: this.registrationData.practicingClinicEmailID,
          chikenpoxVaricellaVaccineDate: this.registrationData.chikenpoxVaricellaVaccineDate,
          diptheriaDTapVaccineDate: this.registrationData.diptheriaDTapVaccineDate,
          haemophilusInfluenzaTypeBHiBVaccineDate: this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate,
          hepatitisAHepAVaccineDate: this.registrationData.hepatitisAHepAVaccineDate,
          hepatitisBHepBVaccineDate: this.registrationData.hepatitisBHepBVaccineDate,
          tetanusDTapDate: this.registrationData.tetanusDTapDate,
          studentPhotoUrl: !_.isEmpty(this.registrationData.studentPhotoUrl) ? this.registrationData.studentPhotoUrl : '',
          fatherPhotoUrl: !_.isEmpty(this.registrationData.fatherPhotoUrl) ? this.registrationData.fatherPhotoUrl : '',
          motherPhotoUrl: !_.isEmpty(this.registrationData.motherPhotoUrl) ? this.registrationData.motherPhotoUrl : '',
          birthCertificateUrl: !_.isEmpty(this.registrationData.birthCertificateUrl) ? this.registrationData.birthCertificateUrl : '',
          transferCertificateUrl: !_.isEmpty(this.registrationData.transferCertificateUrl) ? this.registrationData.transferCertificateUrl : '',
          immunisationCertificateUrl: !_.isEmpty(this.registrationData.immunisationCertificateUrl) ? this.registrationData.immunisationCertificateUrl : '',
          studentAadharCardUrl: !_.isEmpty(this.registrationData.studentAadharCardUrl) ? this.registrationData.studentAadharCardUrl : '',
          fatherAadharCardUrl: !_.isEmpty(this.registrationData.fatherAadharCardUrl) ? this.registrationData.fatherAadharCardUrl : '',
          motherAadharCardUrl: !_.isEmpty(this.registrationData.motherAadharCardUrl) ? this.registrationData.motherAadharCardUrl : '',
          healthCertificateUrl: !_.isEmpty(this.registrationData.healthCertificateUrl) ? this.registrationData.healthCertificateUrl : '',
          senCertificateUrl: !_.isEmpty(this.registrationData.senCertificateUrl) ? this.registrationData.senCertificateUrl : '',
          studentPhoto: this.registrationData.studentPhoto,
          fatherPhoto: this.registrationData.fatherPhoto,
          motherPhoto: this.registrationData.motherPhoto,
          birthCertificate: this.registrationData.birthCertificate,
          transferCertificate: this.registrationData.transferCertificate,
          immunisationCertificate: this.registrationData.immunisationCertificate,
          studentAadharCard: this.registrationData.studentAadharCard,
          fatherAadharCard: this.registrationData.fatherAadharCard,
          motherAadharCard: this.registrationData.motherAadharCard,
          healthCertificate: this.registrationData.healthCertificate,
          senCertificate: this.registrationData.senCertificate,
          registrationCode: this.registrationData.registrationCode,
          enquiryCode: this.studentData.enquiryCode,
          iAgreeCheckbox: this.registrationData.iAgreeCheckbox
        }
        if (!this.isUniformSelectionNotRequired) {
          // Saving Uniform Selection
          await http.post(`${constants.API_URL}/api/product/student-appreal-application`, {
            franchiseeID: this.parentdata.franchisee.id,
            academicYearID: this.parentdata.academicYearID,
            studentAppreals: this.parentdata.studentAppreals,
            enquiryID: this.parentdata.id,
            gender: this.parentdata.gender
          })
        }
        const formData = new FormData()
        for (var key in inputData) {
          if (typeof inputData[key] === 'undefined' || inputData[key] === null) {
            inputData[key] = ''
          }
          formData.append(key, inputData[key])
        }

        await http.put(`${constants.API_URL}/api/edit-registration/${this.refID}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        this.dialog = true

        // this.$router.push({ name: 'PlanAssignInstallmentList', params: { referenceID: this.refID } })

        /*
        this.loader = false
        this.$router.push({ name: 'thankyou' })

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Registration updated successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        }) */
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While updating registration Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    }
  }
}
</script>
